import React from 'react';
import ReactDOM from 'react-dom';
import Modal from "react-responsive-modal";
import {ToastsContainer, ToastsStore, ToastsContainerPosition} from 'react-toasts';
import { getlanguagelist } from "../../helpers/changelanguage";
import "./auth.css"
 

const customStyles = {
    width: '556px',
    position: 'relative'
  };
const VerifyOtp = (props) => {
  const { otpmodal } = props;
  
 
  function closeModal(){
    //$("#otp").val('');
    $("#emailotp").val('')
    props.onOtpClose();
  }
  const onSubmit = () => {
  
    props.onOtpSubmit($("#emailotp").val());
    //$("#otp").val('');
    $("#emailotp").val('');
  }
  const resend = (type) => {
    props.resend(type);
  }
  let  languagelist = getlanguagelist();
 
    return (
     
       
        <Modal open={otpmodal} onClose={closeModal} showCloseIcon={false} center>
          
       
          <div className="modal-header2">
            <button type="button" className="close" onClick={closeModal} ><img src="/assets/images/close_btn.png"/></button>
            
          </div>
          <div className="modal-body" style={customStyles}>
          
          <ToastsContainer store={ToastsStore} position={ToastsContainerPosition.TOP_CENTER} lightBackground />
         {/*  <div className="row">
             <input 
              className="form-control"
              placeholder={languagelist.verifyph}
              name="otp"
              id="otp" 
             />
              <span className="pull-right"><a onClick={() => resend('mobile')} style={{cursor : 'pointer'}}>Resend</a></span>
          </div> */}
             
                <div className="row">
                  <input 
                    className="form-control"
                    placeholder={languagelist.emailotp}
                    name="emailotp"
                    id="emailotp" 
                  />
                  <span className="pull-right"><a onClick={() => resend('email')} style={{cursor : 'pointer'}}>Resend</a></span>
                </div>
                
             
            
          </div>
          <div className="modal-footer">
            <input type="button" className="otp_btn" value={languagelist.btnverify} onClick={onSubmit}/>
          </div>
          
        

      </Modal>
    
    );
}
export default VerifyOtp;